export const openInNewTab = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const Cookie = {
  set: (name: string, value: string, expireDays?: number, path: string = "/") => {
    let c = `${name}=${encodeURIComponent(value)}`;
    if (expireDays) {
      const d = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      c = `${c}; expires=${d.toUTCString()}`;
    }
    document.cookie = `${c};domain=${window.location.hostname}; path=/`;
  },
  get: (name: string): string | undefined => {
    const match = document.cookie.match(RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
  },
  delete: (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
};
